module.exports = __webpack_public_path__ + "static/media/energy-labeling-product.a3cf182b.jpg";